export const DEFAULT_COORDINATES = 0.000001
export const DEFAULT_IMAGE = 'https://froth-bucket.nyc3.digitaloceanspaces.com/default-images/default-image.png'
export const VALID_LENGTH_CARD_NUMBER = 16
export const VALID_LENGTH_CARD_EXPIRY = 6
export const JOB_ROLES = [
  { value: 'barista', label: 'Barista' },
]
